import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/configuration/setup/store';

export const FEATURE_SLICE_NAME = 'featureToggle';

const CURRENT_TOGGLES = [] as const;

type KnownToggles = TypeFromArray<typeof CURRENT_TOGGLES>;

/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-shadow */
type TypeFromArray<T extends readonly unknown[]> = T extends readonly (infer TypeFromArray)[] ? TypeFromArray : never;

type EventContent = {
    featureKey: string;
    value: string | undefined;
};

export type FeatureToggleState = {
    features: Record<string, boolean>;
};

const initialState: FeatureToggleState = {
    features: {},
};

const featureToggleSlice = createSlice({
    initialState,
    name: FEATURE_SLICE_NAME,
    reducers: {
        featureToggleChanged: (state: FeatureToggleState, action: PayloadAction<EventContent>) => {
            const { featureKey, value } = action.payload;
            if ((CURRENT_TOGGLES as readonly string[]).includes(featureKey)) {
                state.features[featureKey] = value !== undefined ? /true/i.test(value) : false;
            }
        },
    },
});

// This is a selector, needs to be used with useAppSelector hook
export const isFeatureEnabled = (feature: KnownToggles) => (state: RootState) =>
    state[FEATURE_SLICE_NAME].features[feature] ?? false;

export const { featureToggleChanged } = featureToggleSlice.actions;
export default featureToggleSlice.reducer;
